import { createApp } from "vue";
import "./styles/app.css";

import App from "./App.vue";
import './registerServiceWorker'

const app = createApp(App);
app.mount("#app");
